import get from "lodash.get";
import styled from "styled-components";

export const NewsBoxStyle = styled.div`
  position: relative;
  .wrapper {
    position: absolute;
    right: 0;
    border-radius: 10px;
    background-color: ${({ theme }) => get(theme, "background.main")};
    width: 400px;
    max-height: 400px;
    box-shadow: 0px 0px 2px 0px rgba(160, 160, 160, 0.75);
    overflow: auto;
    z-index: 1000;
    .title {
      border-bottom: 1px solid ${({ theme }) => get(theme, "border.main")};
      padding: 16px;
      color: ${({ theme }) => get(theme, "text.main")};
    }
    .list {
      margin: 5px 0;
      .no_news {
        color: ${({ theme }) => get(theme, "text.main")};
      }
    }
    .item {
      position: relative;
      padding: 6px 16px;
      color: ${({ theme }) => get(theme, "text.main")};

      &:hover {
        background-color: ${({ theme }) => get(theme, "background.hoverPrimary")};
      }

      .arrow {
        position: absolute;
        top: 2px;
        left: 0;
        display: block;
        width: 2px;
        height: 90%;
        background-color: #0d6efd;
      }
    }
  }

  .news_modal_head {
    .news_img {
      width: 120px !important;
    }
  }

  .more_text {
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    color: green;
    display: block;
    padding-bottom: 10px;
  }

  .no_news {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    h4 {
      font-size: 18px;
    }
  }
`;

export const CustomIconStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 5px;
  transition: 0.2s ease all;
  cursor: pointer;
  svg {
    width: 20px;
    height: 20px;
    path {
      fill: ${({ theme }) => get(theme, "secondary.dark")};
      transition: 0.2s ease all;
    }
  }
  &:hover,
  &.active {
    background-color: ${({ theme }) => get(theme, "primary.light")};
    svg {
      path {
        fill: ${({ theme }) => get(theme, "primary.main")};
      }
    }
  }
`;

export const NewsBoxModal = styled.div`
  min-height: 200px;
  img {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }

  h4 {
    font-size: 18px;
  }

  .news_texts {
    max-height: 400px;
    overflow: auto;
  }

  a {
    word-break: break-all;
  }
`;
